import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'

export const useArticle = (urlId = null, params = {}) => {
  const { options, swrOptions } = params
  const { data, ...rest } = useCustomSWR(
    urlId &&
      `/articles?${stringify({ urlId, isShowContent: true, ...options })}`,
    swrOptions
  )
  return { data: data?.[0], ...rest }
}
